import React from 'react';
import Loadable from 'react-loadable';
import Loading from 'components/Loading';
import {AppSettings} from '../constants';
import Translate from 'components/translate';
import AddEditProject from './Containers/project-add-edit';

const MangeProject = Loadable({
  loader: () => import('./Containers/project-manage'),
  loading: Loading
});

// const AddEditProject = Loadable({
//   loader: () => import('./Containers/add-edit-project'),
//   loading: Loading
// });

const AssignSubToProject = Loadable({
  loader: () => import('./Containers/project-assign-sub'),
  loading: Loading
});

const AddPhase = Loadable({
  loader: () => import('./Containers/project-add-edit-phase'),
  loading: Loading
});

export default [
  {
    path: '/projects',
    component: MangeProject,
    private: true,
    portal: ['Builder'],
    menu: {
      name: <Translate translateKey='project' plurals capitalize />,
      order: 2,
      icons: 'icon-projects-ic',
      condition: () => {
        return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  },
  {
    path: '/projects/add',
    component: AddEditProject,
    portal: ['Builder'],
    private: true
  },
  {
    path: '/projects/edit/:projectId',
    component: AddEditProject,
    portal: ['Builder'],
    private: true
  },
  {
    path: '/projects/assign-sub-to-project/:projectId',
    component: AssignSubToProject,
    portal: ['Builder'],
    private: true
  },
  {
    path: '/phases/add/:projectId/:isNew',
    component: AddPhase,
    portal: ['Builder'],
    private: true
  }
];



// WEBPACK FOOTER //
// ./src/Projects/routes.js